import React from "react";

import FidelityZerosix from "../FidelityFranchise/FidelityZerosix";
import { FidelityFormApi } from "../useFidelityForm";

type Props = {
    form: FidelityFormApi;
    setIsEdited: (v: boolean) => void;
};

export default function ZerosixSection({ form, setIsEdited }: Props) {
    const { values, errors, setValue, setError } = form;

    return (
        <FidelityZerosix
            password={values.password}
            setPassword={(v: string) => setValue("password", v)}
            user={values.user}
            setUser={(v: string) => setValue("user", v)}
            inputUser={errors.user}
            setInputUser={(v: boolean) => setError("user", v)}
            inputPassword={errors.password}
            setInputPassword={(v: boolean) => setError("password", v)}
            setIsEdited={setIsEdited}
            dashboardLink={values.dashboardLink}
            setDashboardLink={(v: string) => setValue("dashboardLink", v)}
            setApiKey={(v: string) => setValue("apiKey", v)}
            apiKey={values.apiKey}
            inputDashboardLink={errors.dashboardLink}
            inputApiKey={errors.apiKey}
            setInputDashboardLink={(v: boolean) => setError("dashboardLink", v)}
            setInputApiKey={(v: boolean) => setError("apiKey", v)}
        />
    );
}
